import { css, useTheme } from "@emotion/react"
import React from "react"
import { VerticalDivider } from "../dividers/VerticalDivider"
import { BodyTextRegular, BodyTextSemibold } from "../typography/text"
import { useDynamicTranslation } from "../../hooks/use-dynamic-translation"
import { translationKeys } from "../../util/translationKeys"
import { useTranslation } from "react-i18next"

type Props = {
  opensAt: string | null
  closingAt: string | null
  isOpen: boolean
}

const wrapperStyle = css`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
`

export const RestaurantStatus = ({ opensAt, closingAt, isOpen }: Props) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const tDynamic = useDynamicTranslation()
  const openingIndicatorStyle = css`
    width: 8px;
    height: 8px;
    background: ${!isOpen ? "#FF3737" : "#37FF87"};
    border-radius: 100px;
  `
  const opensAtOrClosesAtText = opensAt
    ? tDynamic(translationKeys.webRestaurantOpensat, [opensAt])
    : closingAt
    ? tDynamic(translationKeys.venuedetailsClosingAt, [closingAt])
    : null

  return (
    <div css={wrapperStyle}>
      <div css={openingIndicatorStyle} />
      <BodyTextSemibold color={theme.colors.white}>
        {!isOpen
          ? t(translationKeys.webRestaurantClosed)
          : t(translationKeys.webRestaurantOpen)}
      </BodyTextSemibold>
      {opensAtOrClosesAtText && (
        <>
          <VerticalDivider
            backgroundColor={theme.colors.greyBorder}
            height="16px"
          ></VerticalDivider>
          <BodyTextRegular color={theme.colors.greyBorder}>
            {opensAtOrClosesAtText}
          </BodyTextRegular>
        </>
      )}
    </div>
  )
}
